import api from "./axios";

export const getAddons = async () => {
  return await api.get("/api/web-api/public/shop/options/get-options");
};
